// src/utils/plan/planLinks.js
//
// Canonical openers for the plan authoring surfaces. Kept in one place so every
// entry point (the student Plan tab, the Plans hub, prep cards) targets the same
// pages. All of them open in a new browser tab.

import { isCustomPlan } from "./planConfig";

/** Full-page SAT/ACT plan workspace — query is e.g. `mode=edit&planId=<id>`. */
export function openPlanTab(query) {
  window.open(`/diagnostics/plan?${query}`, "_blank", "noopener");
}

/** Custom-plan authoring page (any subject) — query is studentId/name/planId. */
export function openCustomPlanTab(query) {
  window.open(`/students/plan/custom?${query}`, "_blank", "noopener");
}

/**
 * Open the right editor for a plan in a new tab: the custom-plan editor for
 * custom plans, the SAT/ACT diagnostic workspace otherwise.
 */
export function openPlanEditor(plan, { studentId = "", studentName = "" } = {}) {
  if (!plan?.id) return;
  if (isCustomPlan(plan)) {
    openCustomPlanTab(
      `studentId=${encodeURIComponent(plan.studentDirId || studentId || "")}` +
        `&name=${encodeURIComponent(studentName || "")}` +
        `&planId=${encodeURIComponent(plan.id)}`
    );
    return;
  }
  openPlanTab(`mode=edit&planId=${encodeURIComponent(plan.id)}`);
}
